import { useRouter } from "next/router";

export const useActivePath = (path) => {
  const { pathname } = useRouter(); // use useRouter to extract pathname instead of usePathname to show rendered page name (to handle error page)
  return (
    pathname.startsWith(path) || (path.includes(pathname) && pathname !== "/")
  );
};
